// Paletas del dashboard resumen. Las donas reciben el color ya asignado en
// cada item (ver utils.js), para que leyenda, tooltip y porcion coincidan.
export const COLOR_VENTAS = "#2563eb";
export const COLOR_VENTAS_ANTERIOR = "#f97316";
export const COLOR_SIN_DATOS = "#e5e7eb";
export const COLORES_CATEGORIA = ["#3b82f6", "#22c55e", "#f59e0b", "#a855f7", "#06b6d4", "#ef4444", "#64748b", "#ec4899"];

// Los estados conocidos mantienen siempre el mismo color; cualquier otro
// estado que mande el backend toma un color de COLORES_ESTADO_OTROS.
export const COLORES_ESTADO = {
    EMITIDO: "#22c55e",
    REGISTRADO: "#3b82f6",
    RECHAZADO: "#f59e0b",
    ANULADO: "#ef4444",
};
export const COLORES_ESTADO_OTROS = ["#8b5cf6", "#06b6d4", "#64748b", "#ec4899"];

export const ESTILOS_ESTABLECIMIENTO = [
    { color: "#2563eb", fondo: "#dbeafe" },
    { color: "#16a34a", fondo: "#dcfce7" },
    { color: "#7c3aed", fondo: "#ede9fe" },
    { color: "#ea580c", fondo: "#ffedd5" },
];

export const NOMBRES_MES_CORTO = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];
